
import { observer } from 'mobx-react-lite';
//
import { SectionTab } from 'polotno/side-panel';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
// import our own icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { faCrop, faCropAlt } from '@fortawesome/free-solid-svg-icons';
import { CircularProgress } from '@mui/material';
import { url } from '../../../services';
export const CardPanel = observer(({ store }) => {
    const [images, setImages] = useState([]);
    const [isMaxGet, setIsMaxGet] = useState(false);
    const [isHaveQueue, setIsHaveQueue] = useState(false);
    const [indexGetImg, setindexGetImg] = useState(0);
    async function loadImages(numbImg) {
        let maxTextLength = 93
        // let size = store.width + "" + store.height
        // if (size == "815315") maxTextLength = 100
        // if (size == "10801920") maxTextLength = 100
        let listImg = Object.assign([], images)
        const maxNum = numbImg + 30
        for (numbImg; numbImg < maxNum; numbImg++) {
            if (numbImg > maxTextLength) {
                setIsMaxGet(true)
                break
            }
            else {
                listImg.push({ index: numbImg, url: url + 'resource/greatingcard/' + numbImg + '.svg?size=10801920', data: url + 'resource/greatingcard/' + numbImg + '.svg?size=10801920' })
            }
        }
        setImages(listImg);
    }

    useEffect(() => {
        loadImages(0);
    }, []);

    const handleScrollList = (event) => {
        if (!isMaxGet) {
            const element = event.target
            if (Math.round(element.scrollHeight - element.scrollTop) === element.clientHeight) {
                let newIndex = indexGetImg + 15
                setindexGetImg(newIndex)
                loadImages(newIndex);
            }
        }
    }
    return (
        <div className="list-image-container" onScroll={(e) => handleScrollList(e)}>
            <div style={{ position: "relative" }}>
                {console.log(images)}
                {images.map((item, key) => (
                    <img src={item.url} alt="" key={key} className="img-item" onClick={async () => {

                        // download selected json
                        setIsHaveQueue(true)

                        const svgElement = store.activePage?.addElement({
                            type: 'svg',
                            src: item.data,
                            maskSrc: '', // should we draw mask image over svg element?
                            keepRatio: false, // can we change aspect ration of svg?
                            x: store.width / 2,
                            y: store.height / 2,
                            rotation: 0,
                            locked: false,
                            blurEnabled: false,
                            blurRadius: 10,
                            brightnessEnabled: false,
                            brightness: 0,
                            shadowEnabled: false,
                            shadowBlur: 10,
                            width: 200,
                            height: 200,
                            flipX: false,
                            flipY: false,
                            // can user select element?
                            // if false, element will be "invisible" for user clicks
                            selectable: true,
                            // use for absolute positing of element
                            alwaysOnTop: false,
                            // also we can hide some elements from the export
                            showInExport: true,
                        });
                        await store.waitLoading();
                        setIsHaveQueue(false)

                        // const req = await fetch(item.data);
                        // const json = await req.json()
                        // store.loadJSON(json, true);
                        // await store.waitLoading();
                        // setIsHaveQueue(false)
                        // await axios({
                        //     method: "GET",
                        //     url: item.data
                        // }).then(async res => {
                        //     await store.loadJSON(res.data)
                        // })
                    }} />
                ))}
                {
                    !isMaxGet ?
                        <div style={{ marginBottom: "1em", textAlign: "center" }}>
                            <CircularProgress />
                        </div>
                        : null}
                {isHaveQueue ?
                    <div style={{
                        position: "absolute",
                        top: 0,
                        height: "100%",
                        width: "100%",
                        backgroundColor: "rgba(255,255,255,0.5)",
                        textAlign: "center"
                    }}>
                        <CircularProgress style={{
                            position: "fixed",
                            top: "50%",
                        }} />
                    </div>
                    : null}
            </div>
        </div>

    );
});
// define the new custom section
export const Sticker = {
    name: 'Sticker',
    Tab: (props) => (
        <SectionTab name="Sticker" {...props}>
            <FontAwesomeIcon icon={faCrop} />
        </SectionTab>
    ),
    Panel: CardPanel,
};